/* global window */

import { Component } from 'react';

class C7FormSuccess extends Component {
  componentDidMount() {
    if (this.c7Message) {
      this.c7Message.scrollIntoView();
      window.scrollBy(0, -150);
    }
  }

  componentDidUpdate() {
    if (this.c7Message) {
      this.c7Message.scrollIntoView();
      window.scrollBy(0, -150);
    }
  }

  render() {
    const { thankYouMessage } = this.props;
    if (!thankYouMessage) {
      return (
        <div
          className="c7-message"
          ref={(div) => {
            this.c7Message = div;
          }}
        >
          <p>Thank you completing the form.</p>
        </div>
      );
    }
    return (
      <div
        className="c7-message"
        dangerouslySetInnerHTML={{
          __html: thankYouMessage
        }}
        ref={(div) => {
          this.c7Message = div;
        }}
      />
    );
  }
}

export default C7FormSuccess;
